import React, { useState, useRef } from 'react';
import {
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Container,
  useMediaQuery,
  useTheme,
  Box,
  Link,
  Avatar,
  Menu,
  MenuItem,
  Grid
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LanguageIcon from '@mui/icons-material/Language';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { login, logout } from '../../store/store';
import Cookies from 'js-cookie';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'About us', href: '/about-us' },
  { label: 'Lockers', href: '/locker' },
  { label: 'Blog', href: '/blog' },
  { label: 'Contact us', href: '/contact-us' },
  {
    label: 'Login or Sign Up',
    href: '#',
    modalTarget: 'modal',
    modalId: '#exampleModal',
  },
  { label: 'English', href: '#' },
];

function Header() {
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [mobileError, setMobileError] = useState('');
  const [otpError, setOtpError] = useState('');
  const [age, setAge] = useState('');
  const [address, setAddress] = useState('');
  const [password, setPassword] = useState('');

  const inputs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const handleSendOtp = async () => {
    setMobileError('');

    if (!/^\d{10}$/.test(mobile)) {
      setMobileError('Please enter a valid 10-digit mobile number.');
      return;
    }

    try {
      const response = await axios.post('https://userapp-backend.mandir.wiki/api/v1/otp/send', {
        phone: mobile,
      });

      if (response.status === 200) {
        setOtpSent(true);
        setOtp('');
        setMobileError('');
      } else {
        setMobileError('Failed to send OTP. Please try again.');
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
      setMobileError('Failed to send OTP. Please try again.');
    }
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/, '');
    const otpArray = otp.split('');
    otpArray[index] = value;
    setOtp(otpArray.join(''));

    if (value && index < 5) {
      inputs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && (!otp[index] || otp[index] === '')) {
      if (index > 0) inputs[index - 1].current.focus();
    }
  };

  // const handleVerifyOtp = async (e) => {
  //   e.preventDefault();
  //   setOtpError('');

  //   if (otp.length !== 6) {
  //     setOtpError('Please enter a 6-digit OTP.');
  //     return;
  //   }

  //   try {
  //     const response = await axios.post('https://userapp-backend.mandir.wiki/api/v1/otp/verify', {
  //       phone: mobile,
  //       otp: otp,
  //     });

  //     // if (response.status === 200) {
  //     //   setOtpVerified(true);
  //     //   const randomToken = Math.random().toString(36).substring(2);
  //     //   dispatch(login(randomToken));
  //     // }
  //     if (response.status === 200) {
  //       if(response?.message === "Login successful."){
  //          setOtpVerified(false);
  //            const token = Cookies.get('token');
  //             dispatch(login(token));
  //             // Close the modal after a short delay
  //             const closeBtn = document.getElementById('closeBTN');
  //             if (closeBtn) closeBtn.click();
  //             setShowSuccess(false);
  //       }else{
  //          setOtpVerified(true);
  //       }

  //           }
  //      else {
  //       setOtpError('Invalid OTP. Please try again.');
  //     }
  //   } catch (error) {
  //     console.error('Error verifying OTP:', error);
  //     setOtpError('OTP verification failed. Please try again.');
  //   }
  // };



  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setOtpError('');

    if (otp.length !== 6) {
      setOtpError('Please enter a 6-digit OTP.');
      return;
    }

    try {
      const res = await axios.post('https://userapp-backend.mandir.wiki/api/v1/otp/verify', {
        phone: mobile,
        otp: otp,
      });

      const message = res?.data?.message;

      if (res.status === 200 && message) {
        if (message === "Login successful.") {
          // Existing user - login
          const token = Cookies.get('token');
          dispatch(login(token));
          setOtpVerified(false); // So form doesn't show
          setShowSuccess(true);
          // Close modal after a small delay
          setTimeout(() => {
            const closeBtn = document.getElementById('closeBTN');
            if (closeBtn) closeBtn.click();
            setShowSuccess(false);
          }, 1500);
        } else {
          // New user - show profile form
          setOtpVerified(true);
        }
      } else {
        setOtpError('Invalid OTP. Please try again.');
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      setOtpError('OTP verification failed. Please try again.');
    }
  };



  const handleProfileSubmit = async () => {
    try {
      const payload = {
        name: fullName,
        email: email,
        password: password,
        age: parseInt(age),
        phone: mobile,
        address: address,
      };

      const res = await axios.post('https://userapp-backend.mandir.wiki/api/v1/users/register', payload);

      if (res.status === 201 || res.status === 200) {
        const token = res.data?.data?.token;

        if (token) {
          Cookies.set('token', token); // Optional: persist token in cookie
          dispatch(login(token)); // Login using redux action
        }

        setShowSuccess(true);

        // Close modal after short delay
        setTimeout(() => {
          const closeBtn = document.getElementById('closeBTN');
          if (closeBtn) closeBtn.click();
          setShowSuccess(false);
          setOtpVerified(false);
        }, 1500);
      } else {
        alert('Registration failed. Please try again.');
      }
    } catch (error) {
      console.error('Error during registration:', error);
      alert('An error occurred while registering. Please check your inputs and try again.');
    }
  };



  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = () => {
    setAnchorEl(null);
    dispatch(logout());
  };

  return (
    <div className="header">
      <Container maxWidth="lg" className="header__container">
        <div className="header__logo">
          <Link href="/"><img src="/assets/logo.svg" alt="Logo" /></Link>
        </div>

        {isMobile ? (
          <>
            <IconButton className="header__menuIcon" edge="end" color="inherit" onClick={handleDrawerToggle}>
              <MenuIcon />
            </IconButton>
            <Drawer anchor="right" open={mobileOpen} onClose={handleDrawerToggle}>
              <div className="header__drawer">
                <List>
                  {navLinks.map((item) => {
                    if (item.label === 'Login or Sign Up') {
                      return (
                        <ListItem button key="auth" onClick={handleDrawerToggle}>
                          <ListItemText>
                            {isAuthenticated ? (
                              <button onClick={handleSignOut} className="btn btn-danger w-100">Logout</button>
                            ) : (
                              <Link href="#" underline="none">
                                <span role="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                  Login or Sign Up <KeyboardArrowDownIcon className="d-icon" />
                                </span>
                              </Link>
                            )}
                          </ListItemText>
                        </ListItem>
                      );
                    }

                    return (
                      <ListItem button key={item.label} onClick={handleDrawerToggle}>
                        <ListItemText>
                          <Link href={item.href} underline="none">
                            {item.label}
                            {item.label === 'English' && <><LanguageIcon /><KeyboardArrowDownIcon className="d-icon"/></>}
                          </Link>
                        </ListItemText>
                      </ListItem>
                    );
                  })}
                </List>
              </div>
            </Drawer>
          </>
        ) : (
          <div className="header__nav">
            <ul>
              {navLinks.map((item) => {
                if (item.label === 'Login or Sign Up') {
                  return (
                    <li key="auth" className={isAuthenticated ? 'profileIcon' : ''}>
                      {isAuthenticated ? (
                        <>
                          <Avatar
                            alt="Profile"
                            src="/assets/user-avatar.png"
                            onClick={handleProfileClick}
                            style={{ cursor: 'pointer' }}
                          />
                          <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                          >
                            <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
                          </Menu>
                        </>
                      ) : (
                        <Link href={item.href} underline="none">
                          <span
                            role="button"
                            data-bs-toggle={item.modalTarget}
                            data-bs-target={item.modalId}
                          >
                            {item.label} <KeyboardArrowDownIcon className="d-icon" />
                          </span>
                        </Link>
                      )}
                    </li>
                  );
                }

                return (
                  <li key={item.label}>
                    <Link href={item.href} underline="none">
                      {item.label}
                      {item.label === 'English' && (
                        <>
                          <LanguageIcon  />
                          <KeyboardArrowDownIcon className="d-icon" />
                        </>
                      )}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </Container>

      {/* Modal HTML */}
      <div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content auth-modal">
            <div className="modal-body d-flex p-0">
              <div className="auth-image d-none d-md-block">
                <div className="modalOpacity"></div>
                <div className="modalContent">
                  <img src="/assets/white-logo.png" alt="Auth" />
                </div>
              </div>

              <button
                id='closeBTN'
                type="button"
                className="btn-close btnClose"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>

              <div className="auth-form-wrapper p-5 flex-grow-1">
                <div className={`mobileNone ${otpSent ? 'd-none' : ''}`}>
                  <h4 className="mb-3">Mobile No.</h4>
                  <p>Please enter your valid phone number. We will send you a 6-digit code to verify your account.</p>
                </div>

                <form className="auth-form" onSubmit={handleVerifyOtp}>
                  {!otpSent ? (
                    <>
                      <div className="mb-3">
                        <input
                          type="tel"
                          className={`form-control ${mobileError ? 'is-invalid' : ''}`}
                          placeholder="Enter mobile number"
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                          maxLength="10"
                        />
                        {mobileError && <div className="invalid-feedback">{mobileError}</div>}
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={handleSendOtp}
                      >
                        Request for OTP
                      </button>


                       
                    </>
                  ) : !otpVerified ? (
                    <>
                   
                      <div className="mb-3">
                        <h4 className="mb-0">Mobile No.</h4>
                        <p className="mb-2 d-block">Enter OTP sent to {mobile}</p>
                        <div className="d-flex gap-3 justify-content-start">
                          {[0, 1, 2, 3, 4, 5].map((i) => (
                            <input
                              key={i}
                              ref={inputs[i]}
                              type="text"
                              inputMode="numeric"
                              maxLength="1"
                              className="form-control text-center otpInput"
                              style={{ width: '50px', fontSize: '1.5rem' }}
                              value={otp[i] || ''}
                              onChange={(e) => handleOtpChange(e, i)}
                              onKeyDown={(e) => handleKeyDown(e, i)}
                            />
                          ))}
                        </div>
                        {otpError && <div className="text-danger mt-2">{otpError}</div>}
                        <div className='d-flex justify-content-between align-items-center mt-3 mb-4'>
                          <label>Expires in 02:00 Minutes</label>
                          <strong>Resend OTP</strong>
                        </div>
                        <div>
                          <p>
                            By continuing to Verify, I agree to Mandirwiki <Link href="terms-condition">Terms & Conditions</Link> and the <Link href="privacy-policy">Privacy Policy</Link>
                          </p>
                        </div>
                      </div>
                      <button type="submit" className="btn btn-success w-100">Verify OTP & Continue</button>
                     
                     
                    </>
                  ) : (
                    <>
                      <h4 className="mb-1">New User, Profile Details</h4>
                      <p className="mb-4 d-block">Please enter your valid details and register here</p>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Full Name"
                              value={fullName}
                              onChange={(e) => setFullName(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Age"
                              value={age}
                              onChange={(e) => setAge(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="mb-3">
                            <input
                              type="password"
                              className="form-control"
                              placeholder="Password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>

                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={handleProfileSubmit}
                      >
                        Complete Profile
                      </button>
                    </>


                  )}
                </form>

                <p className="googleLoginBar"><span> Or Login With </span></p>
                <Box className="socialIcon">
                  <ul className="d-flex gap-3 list-unstyled justify-content-center">
                    <li><Link href="#"><img src="/assets/search.png" height="35" width="35" alt="Google" /></Link></li>
                    <li><Link href="#"><img src="/assets/facebook.png" height="35" width="35" alt="Facebook" /></Link></li>
                  </ul>
                </Box>
              </div>
            </div>
          </div>
        </div>

        {showSuccess && (
          <div
            className="position-fixed top-50 start-50 translate-middle bg-white p-4 shadow rounded text-center"
            style={{ zIndex: 1060, minWidth: '300px' }}
          >
            <h5 className="mb-3 text-success">✅ Login Successful!</h5>
            <p>Welcome to Mandirwiki, {fullName}.</p>
            <button
              className="btn btn-primary mt-3"
              onClick={() => {
                setShowSuccess(false);
                const closeBtn = document.getElementById('closeBTN');
                if (closeBtn) closeBtn.click();
              }}
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;
